<template>
  <el-menu router class="el-menu-vertical-demo" unique-opened :default-active="$route.path"
    background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
    <el-submenu :index="item.path" v-for="(item, i) in this.menus" :key="i">
      <template slot="title">
        <i :class="item.icon"></i>
        <span>{{item.name}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item :index="subItem.path" v-for="subItem in item.childrens" :key="subItem.path">{{subItem.name}}</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  name: 'MenuBar',
  data () {
    return {
      menus: []
    }
  },
  create () {
  },
  mounted () {
    this.getMenus()
  },
  methods: {
    getMenus () {
      var m = localStorage.getItem('menus')
      this.menus = JSON.parse(m)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PageMenu.vue